<template>
  <div class="header-wrap flex flex-col md:flex-row relative">
    <img src="~/assets/img/characters/character-side.svg" alt="" aria-hidden="true" class="absolute character-right">
    <img src="~/assets/img/shapes/circle-filled.svg" alt="" aria-hidden="true" class="absolute circle-right">
    <nuxt-link to="/contact" class="order-2 md:absolute speechbubble">
      <img src="~/assets/img/shapes/speechbubble2.svg" alt="" class="ml-auto md:m-auto" aria-hidden="true">
      <div class="speechbubble--text">Vraag nu een kennismakingsgesprek aan!</div>
    </nuxt-link>

    <section class="order-1 relative z-20 h-full bg-white px-6 pt-6 ml-3 w-4/5 md:w-3/5">
      <div class="w-full lg:w-3/4 flex flex-col">
        <template v-if="htmlString">
          <h1 v-if="headingText" class="h2 text-secondary">{{ headingText }}</h1>
          <div class="prose" v-html="htmlString"/>
        </template>
        <template v-else>
          <h1 class="h2 text-secondary">Vind een begeleider</h1>
          <p>
            Mijn Superkracht werkt samen met begeleiders door het hele land. Om het vinden van een begeleider die je kind zo goed mogelijk kan helpen makkelijker te maken, kun je op deze pagina gericht een begeleider zoeken.
          </p>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: String,
      default: '',
    },
    headingText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.header-wrap {
  @apply overflow-hidden;
  height: auto;
  @screen lg {
    height: 150px;
  }
  background-image: linear-gradient(to right, theme('colors.secondary.default'), theme('colors.secondary.default') 10%, theme('colors.secondary.light') 90%);
  .character-right {
    @apply hidden z-30;
    height: 200px;
    bottom: -35%;
    right: 3%;
    @screen lg {
      @apply block;
      right: 5%;
    }
  }
  .circle-right {
    @apply z-10;
    width: 250px;
    bottom: -75%;
    right: 0;
    @screen lg {
      right: 5%;
    }
  }
  .speechbubble {
    @apply z-20 right-0;
    top: 15%;
    @apply my-10;
    @screen md {
      @apply block my-0;
    }
    @screen lg {
      right: 15.5%;
    }
    &--text {
      @apply absolute text-white w-1/2;
      right: 2rem;
      padding: .5rem .8rem;
      top: 65%;
      @screen sm {
        @apply w-1/4;
        top: 58%;
      }
      @screen md {
        @apply top-0 left-0 right-auto w-auto pr-8;
      }
    }
  }
}
</style>
